import el from "@cypherpotato/el";
import { Card, CardContent } from "./card";

export function Editor(options, ...children) {

    const {
        value,
        renderValue,
        manipulateValue,
        valueChanged,
        id,
        readonly,
        variant,
        hoverState
    } = options;

    const valueState = el.state.create(value);
    var editor;

    return el("div.editor",
        {
            id,
            init() {
                editor = this;
            },
            classList: [
                readonly === true && "editor-readonly",
                hoverState === false && "editor-no-hover",
                variant && `editor-${variant}`
            ],
            $properties: {
                value: {
                    get() {
                        return valueState.value;
                    },
                    set(v) {
                        valueState.value = v;
                        if (valueChanged) {
                            valueChanged(v);
                        }
                    }
                },
                readonly: {
                    get() {
                        return editor.classList.contains("editor-readonly");
                    },
                    set(v) {
                        editor.classList.toggle("editor-readonly", v);
                    }
                },
                editorTitle: {
                    get() {
                        return this.querySelector(".editor-title").textContent;
                    }
                },
                editorParagraphs: {
                    get() {
                        return [...this.querySelectorAll(".editor-description p")].map(el => el.cloneNode(true));
                    }
                }
            }
        },
        Card(
            ...children,
            EditorContent(
                el.state.listening([valueState], () =>
                    renderValue(
                        valueState.value
                    )
                ),
                {
                    onClick() {
                        const mnfunction = manipulateValue.bind(editor);
                        const manipulationCallback = (result) => {
                            valueState.value = result;
                            if (valueChanged) {
                                valueChanged(result);
                            }
                        };
                        mnfunction(valueState.value, manipulationCallback);
                    },
                    disabled: manipulateValue == null
                }
            )
        )
    )
}

export function EditorRow(...children) {
    return el("div.editor-row.editor.editor-row-card",
        Card(
            CardContent(
                ...children
            )
        )
    );
}

export function EditorDescription(...children) {
    return el("div.editor-description",
        ...children
    )
}

export function EditorTitle(...children) {
    return el("div.editor-title",
        ...children
    )
}

function EditorContent(...args) {
    return el("div.editor-content", ...args);
}